<!-- ╔═══════════════════════════════╗
     ║     SECTION 2 : SOLUTION      ║
     ╚═══════════════════════════════╝ -->
<template>
  <v-sheet id="solution" class="py-10 py-sm-16">
    <v-container>
      <v-row justify="center" class="mb-10 text-center">
        <v-col cols="12" md="10">
          <h2
            :class="[
              'font-weight-bold',
              $vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
            ]"
          >
            {{ $t("section_2_title") }}
          </h2>
        </v-col>
      </v-row>

      <moduleItem
        v-for="(module, i) in modules"
        :key="i"
        :icon="module.icon"
        :title="module.title"
        :text="module.text"
      />
    </v-container>
  </v-sheet>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->
<script>
import Vue from "vue";
import moduleItem from "@/components/cards/moduleItem.vue";
import {
  mdiCurrencyUsdOff,
  mdiFileDocumentEditOutline,
  mdiPaletteOutline,
  mdiQrcode,
  mdiContactlessPaymentCircleOutline,
  mdiArrowDown,
} from "@mdi/js";

export default Vue.extend({
  name: "SolutionSection",
  components: {
    moduleItem,
  },
  data() {
    return {
      icons: {
        inscription: mdiCurrencyUsdOff,
        gestion: mdiFileDocumentEditOutline,
        personnalisation: mdiPaletteOutline,
        qrcode: mdiQrcode,
        diffusion: mdiContactlessPaymentCircleOutline,
        down: mdiArrowDown,
      },
    };
  },

  computed: {
    modules() {
      return [
        {
          icon: this.icons.inscription,
          title: this.$t("solution_inscription_title"),
          text: this.$t("solution_inscription_text"),
        },
        {
          icon: this.icons.gestion,
          title: this.$t("solution_gestion_title"),
          text: this.$t("solution_gestion_text"),
        },
        {
          icon: this.icons.personnalisation,
          title: this.$t("solution_personnalisation_title"),
          text: this.$t("solution_personnalisation_text"),
        },
        {
          icon: this.icons.qrcode,
          title: this.$t("solution_generation_title"),
          text: this.$t("solution_generation_text"),
        },
        {
          icon: this.icons.diffusion,
          title: this.$t("solution_diffusion_title"),
          text: this.$t("solution_diffusion_text"),
        },
      ];
    },
  },
});
</script>
